// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__FphbD","title":"ClientCherryInfo_title__1ALJb","itemText":"ClientCherryInfo_itemText__2cWQi"};